var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-about-us"},_vm._l((_vm.sections),function(section){return _c(section.component,{key:section.id,tag:"component",attrs:{"section":section.data,"namespace":section.namespace}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }